import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbe51c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-center pa-4"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center pa-4"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { colspan: "5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Fecha de entrega"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Estado"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Acciones")
  ])
], -1))

import { ref, computed, watch } from "vue";

import {
  InscripcionTorneoCreadoMasDTO,
  TorneoGestionInfoMasDTO,
} from "@/interfaces/Torneo";
import { getInfoTorneoCreadoMasAsync } from "@/services/TorneosService";
import { ListaDTO } from "@/interfaces/Usuario";
import {
  cancelarInscripcion,
  updateEstadoPago,
} from "@/services/InscripcionesService";
import {
  CrearListaTorneoRequestDTO,
  ModificarListaTorneoRequestDTO,
  RequesListaDTO,
  UpdateEstadoListaMasDTO,
} from "@/interfaces/Lista";
import {
  modificarListaTorneo,
  subirListaTorneo,
  updateEstadoListaMasAsync,
} from "@/services/ListasService";
import ModalError from "@/components/Commons/ModalError.vue";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalAddJugadorTorneoMas from "./ModalAddJugadorTorneoMas.vue";
import ModalSorteo from "../ModalSorteo.vue";
import ModalSubirListaGestionMas from "./ModalSubirListaGestionMas.vue";
import ModalModificarLista from "@/components/Inscripcion/ModalModificarLista.vue";
import ModalListaResultadoTorneo from "@/components/ResultadosTorneos/ModalListaResultadoTorneo.vue";
import ModalParametrosPrimeraRondaMas from "./ModalParametrosPrimeraRondaMas.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TablaInscritosMas',
  props: {
    torneo: {}
  },
  emits: ["inscripcionEliminada", "cambios"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const localInscripciones = ref<InscripcionTorneoCreadoMasDTO[]>([]);
const isLoading = ref<boolean>(true);
const showSorteoModal = ref<boolean>(false);
const showAddJugadorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const localTorneo = ref<TorneoGestionInfoMasDTO>();
const nicks = ref<string[]>();
const showSuccessModalPago = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const currentInscripcionId = ref<number>();
const currentLista = ref<ListaDTO>();

const currentTorneoId = ref<number>();
const currentNick = ref<string>();
const currentEjercito = ref<string>();

const currentUsuarioId = ref<number>();
const showModalAddLista = ref<boolean>(false);
const showSuccessAddLista = ref<boolean>(false);
const showErrorAddLista = ref<boolean>(false);
const showVerListaModal = ref<boolean>(false);
const showSuccessEliminarInscripcion = ref<boolean>(false);
const showErrorEliminarInscripcion = ref<boolean>(false);
const showSuccessEditLista = ref<boolean>(false);
const showSuccessUpdateEstadoLista = ref<boolean>(false);
const showErrorUpdateEstadoLista = ref<boolean>(false);
const showErrorEditLista = ref<boolean>(false);
const showModalEditLista = ref<boolean>(false);
const listaData = ref<string>("");
const search = ref<string>("");
const expandedRows = ref<{ [key: number]: boolean }>({});
const estadoListaOptions = [
  { text: "NO ENTREGADA", color: "red" },
  { text: "ENTREGADA", color: "blue" },
  { text: "ILEGAL", color: "red" },
  { text: "OK", color: "green" },
];
const showModalGenerarRonda1 = ref<boolean>(false);

const updateEstado = async (
  idLista: number,
  estado: string,
  idTorneo: number,
  idUsuario: number
) => {
  isLoading.value = true;
  const updateEstadoListaDTO: UpdateEstadoListaMasDTO = {
    idLista: idLista,
    estado: estado,
    idTorneo: idTorneo,
    idUsuario: idUsuario,
  };

  try {
    updateEstadoListaMasAsync(updateEstadoListaDTO);
    showSuccessUpdateEstadoLista.value = true;
  } catch {
    console.error("Error actualizando el estado de la lista");
    showErrorUpdateEstadoLista.value = true;
  } finally {
    isLoading.value = false;
  }
};

const updatePago = async (idInscripcion: number, estado: string) => {
  isLoading.value = true;

  try {
    if (estado == "NO") estado = "SI";
    else if (estado == "SI") estado = "NO";
    await updateEstadoPago({
      idInscripcion: idInscripcion,
      esPago: estado,
    });
    showSuccessModalPago.value = true;
    isLoading.value = false;

    handleUpdatePago(idInscripcion, estado);
  } catch {
    console.error("Error actualizando el pago");
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
  }
};

const handleAddLista = async (
  idInscripcion: number,
  idUsuario: number,
  idTorneo: number
) => {
  currentTorneoId.value = idTorneo;
  currentUsuarioId.value = idUsuario;
  currentInscripcionId.value = idInscripcion;
  showModalAddLista.value = true;
};

const handleEditLista = async (
  lista: ListaDTO,
  idTorneo: number,
  idUsuario: number
) => {
  currentLista.value = lista;
  currentTorneoId.value = idTorneo;
  currentUsuarioId.value = idUsuario;
  showModalEditLista.value = true;
};

const handleEnviarLista = async (newLista: RequesListaDTO) => {
  if (
    currentInscripcionId.value &&
    currentUsuarioId.value &&
    currentTorneoId.value
  ) {
    isLoading.value = true;
    const requestLista: CrearListaTorneoRequestDTO = {
      idInscripcion: currentInscripcionId.value,
      listaData: newLista.listaData,
      ejercito: newLista.ejercito,
      idUsuario: currentUsuarioId.value,
      idTorneo: currentTorneoId.value,
    };

    try {
      await subirListaTorneo(requestLista);
      showModalAddLista.value = false;
      showSuccessAddLista.value = true;
      refreshTorneo();
    } catch {
      isLoading.value = false;
      showErrorAddLista.value = true;
    } finally {
      isLoading.value = false;
      showModalAddLista.value = false;
    }
  }
};

const modificarLista = async (newLista: RequesListaDTO) => {
  if (
    currentLista.value?.idLista == null ||
    currentLista.value?.idLista == undefined
  ) {
    return;
  }
  isLoading.value = true;
  const requestLista: ModificarListaTorneoRequestDTO = {
    listaData: newLista.listaData,
    idLista: currentLista.value.idLista,
    ejercito: newLista.ejercito,
    idUsuario: currentUsuarioId.value,
    idTorneo: currentTorneoId.value,
  };
  try {
    await modificarListaTorneo(requestLista);
    showSuccessEditLista.value = true;
    refreshTorneo();
  } catch {
    isLoading.value = false;
    showErrorEditLista.value = true;
  } finally {
    isLoading.value = false;
    showModalEditLista.value = false;
  }
};

const handlerModalGenerarRonda1 = async () => {
  showModalGenerarRonda1.value = true;
};

const refreshTorneo = async () => {
  isLoading.value = true;
  try {
    if (props.torneo?.torneo.idTorneo) {
      const responseTorneo = await getInfoTorneoCreadoMasAsync(
        props.torneo?.torneo.idTorneo
      );
      localTorneo.value = responseTorneo.data;
      localInscripciones.value = JSON.parse(
        JSON.stringify(localTorneo.value?.inscripciones)
      );
    }

    emit("cambios", localTorneo.value);
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const openSorteo = async () => {
  isLoading.value = true;
  try {
    nicks.value = localInscripciones.value
      .map((x) => x.nick)
      .filter((nick): nick is string => nick !== null && nick !== undefined);
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
  showSorteoModal.value = true;
};

const closeSorteoModal = () => {
  showSorteoModal.value = false;
};

const openAddJugadorModal = async () => {
  showAddJugadorModal.value = true;
};

const closeModalGenerarRonda1 = () => {
  showModalGenerarRonda1.value = false;
};

const closeAddJugadorModal = () => {
  showAddJugadorModal.value = false;
};

const handleConfirmGenerarRonda1 = () => {
  closeModalGenerarRonda1();
  recargarPagina();
};

const recargarPagina = () => {
  window.location.reload();
};

const handleAddJugadorConfirm = () => {
  showAddJugadorModal.value = false;
  showSuccessModal.value = false;
  refreshTorneo();
};

watch(
  () => props.torneo?.inscripciones,
  (newInscripciones) => {
    if (newInscripciones) {
      localInscripciones.value = [...newInscripciones];
    }
    isLoading.value = false;
  },
  { immediate: true }
);

watch(
  () => showSuccessModal.value,
  (newValue) => {
    if (!newValue) {
      window.location.reload();
    }
  }
);

const emit = __emit;

const headers = computed(() => [
  { title: "Nick", key: "nick" },
  { title: "Fecha Inscripción", key: "fechaInscripcion" },
  { title: "Listas entregadas", key: "estadoLista" },
  { title: "Fecha última entrega", key: "fechaEntrega" },
  { title: "Pagado", key: "esPago" },
  { title: "Eliminar", key: "eliminar" },
]);

const formattedDate = (date: string | null | undefined) => {
  return date ? new Date(date).toLocaleDateString() : "N/A";
};

const chipColor = (
  inscriptionDate: string | null | undefined,
  referenceDate: string | null | undefined
) => {
  if (!inscriptionDate || !referenceDate) return "red";
  return new Date(inscriptionDate) < new Date(referenceDate)
    ? "green"
    : "yellow";
};

const chipNumeroListasColor = (
  numeroListasEnviadas: number,
  listasNecesarias: number
) => {
  return numeroListasEnviadas < listasNecesarias ? "yellow" : "green";
};

const toggleExpand = (id: number) => {
  expandedRows.value[id] = !expandedRows.value[id];
};

const handleUpdatePago = (idInscripcion: number, estado: string) => {
  localInscripciones.value.forEach((i) => {
    if (i.idInscripcion == idInscripcion) {
      i.esPago = estado;
    }
  });
  refreshTorneo();
};

const handleEliminarInscripcion = async (idInscripcion: number) => {
  try {
    const response = await cancelarInscripcion(idInscripcion);

    if (response.request?.status === 200) {
      showSuccessEliminarInscripcion.value = true;
      refreshTorneo();
    }
  } catch {
    showErrorEliminarInscripcion.value = true;
  }
};

const verLista = (lista: ListaDTO, nick: string) => {
  if (lista.listaData) {
    listaData.value = lista.listaData;
    showVerListaModal.value = true;
    currentNick.value = nick;
    currentEjercito.value = lista.ejercito;
  } else {
    console.error("No se puede cargar la lista");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, { flat: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex align-center pe-2" }, {
          default: _withCtx(() => [
            _createTextVNode(" Inscritos "),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_text_field, {
              modelValue: search.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              density: "compact",
              label: "Buscar",
              "prepend-inner-icon": "mdi-magnify",
              variant: "solo-filled",
              flat: "",
              "hide-details": "",
              "single-line": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_divider),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Cargando inscripciones... "))
          : (!isLoading.value && localInscripciones.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, " No hay inscripciones para este torneo "))
            : (_openBlock(), _createBlock(_component_v_data_table, {
                key: 2,
                search: search.value,
                "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                items: localInscripciones.value,
                headers: headers.value,
                class: "custom-table",
                "item-key": "nick"
              }, {
                item: _withCtx(({ item }) => [
                  _createElementVNode("tr", {
                    class: _normalizeClass({ 'expanded-row': expandedRows.value[item.idInscripcion] })
                  }, [
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(item.nick) + " ", 1),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        onClick: _withModifiers(($event: any) => (toggleExpand(item.idInscripcion)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(expandedRows.value[item.idInscripcion]
                    ? "mdi-chevron-up"
                    : "mdi-chevron-down"), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_chip, {
                        color: 
                chipColor(
                  item.fechaInscripcion,
                  _ctx.torneo?.torneo.fechaFinInscripcion
                )
              ,
                        dark: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(formattedDate(item.fechaInscripcion)), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_chip, {
                        color: 
                chipNumeroListasColor(
                  item.countListasEntregadas,
                  _ctx.torneo.torneo.listasPorJugador
                )
              ,
                        dark: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.countListasEntregadas) + "/" + _toDisplayString(_ctx.torneo.torneo.listasPorJugador), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_chip, {
                        color: 
                chipColor(
                  item.fechaUltimaEntrega,
                  _ctx.torneo?.torneo.fechaEntregaListas
                )
              ,
                        dark: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(formattedDate(item.fechaUltimaEntrega)), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(item.esPago === 'SI' ? 'text-success' : 'text-error')
                      }, _toDisplayString(item.esPago), 3),
                      _createVNode(_component_v_icon, {
                        onClick: ($event: any) => (updatePago(item.idInscripcion, item.esPago)),
                        class: "ml-2 cursor-pointer"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" mdi-swap-horizontal ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_icon, {
                        onClick: ($event: any) => (handleEliminarInscripcion(item.idInscripcion)),
                        class: "ml-2 cursor-pointer",
                        color: "red"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" mdi-delete ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ], 2),
                  (expandedRows.value[item.idInscripcion])
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                        _createElementVNode("td", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.torneo.torneo.listasPorJugador, (n) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'slot-' + n,
                              class: "expanded-content"
                            }, [
                              _renderSlot(_ctx.$slots, 'expanded-content-' + n, { item: item }, () => [
                                _createVNode(_component_v_table, { class: "mt-2" }, {
                                  default: _withCtx(() => [
                                    _hoisted_5,
                                    _createElementVNode("tbody", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("td", null, _toDisplayString(n), 1),
                                        _createElementVNode("td", null, [
                                          (item.lista[n - 1])
                                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                                key: 0,
                                                color: 
                            chipColor(
                              item.lista[n - 1].fechaEntrega,
                              _ctx.torneo?.torneo.fechaEntregaListas
                            )
                          ,
                                                dark: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(formattedDate(item.lista[n - 1].fechaEntrega)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["color"]))
                                            : _createCommentVNode("", true),
                                          (!item.lista[n - 1])
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 1,
                                                color: "primary",
                                                variant: "tonal",
                                                onClick: ($event: any) => (
                            handleAddLista(
                              item.idInscripcion,
                              item.idUsuario,
                              item.idTorneo
                            )
                          )
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("subir lista")
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("td", null, [
                                          (item.lista[n - 1])
                                            ? (_openBlock(), _createBlock(_component_v_select, {
                                                key: 0,
                                                items: estadoListaOptions,
                                                modelValue: item.lista[n - 1].estadoLista,
                                                "onUpdate:modelValue": [($event: any) => ((item.lista[n - 1].estadoLista) = $event), 
                            (value) =>
                              updateEstado(
                                item.lista[n - 1].idLista,
                                value,
                                item.idTorneo, 
                                item.idUsuario
                              )
                          ],
                                                "item-title": "text",
                                                "item-value": "text",
                                                chips: ""
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("td", null, [
                                          (item.lista[n - 1])
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                icon: "",
                                                onClick: _withModifiers(($event: any) => (verLista(item.lista[n - 1], item.nick)), ["stop"])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("mdi-eye")
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true),
                                          (item.lista[n - 1])
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 1,
                                                icon: "",
                                                onClick: _withModifiers(($event: any) => (
                            handleEditLista(
                              item.lista[n - 1],
                              item.idTorneo,
                              item.idUsuario
                            )
                          ), ["stop"])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("mdi-file-edit")
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 3
              }, 8, ["search", "items", "headers"])),
        _createVNode(_component_v_row, {
          justify: "center",
          class: "my-4 ga-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              variant: "tonal",
              onClick: openAddJugadorModal,
              color: "secondary",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Añadir Jugador ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              variant: "tonal",
              onClick: handlerModalGenerarRonda1,
              color: "primary",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Generar Ronda 1 ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              variant: "tonal",
              onClick: openSorteo,
              color: "primary",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Sorteo ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.torneo.torneo.idTorneo)
          ? (_openBlock(), _createBlock(ModalParametrosPrimeraRondaMas, {
              key: 3,
              isVisible: showModalGenerarRonda1.value,
              torneo: _ctx.torneo,
              onClose: closeModalGenerarRonda1,
              onConfirm: handleConfirmGenerarRonda1
            }, null, 8, ["isVisible", "torneo"]))
          : _createCommentVNode("", true),
        _createVNode(ModalAddJugadorTorneoMas, {
          isVisible: showAddJugadorModal.value,
          torneo: _ctx.torneo,
          onClose: closeAddJugadorModal,
          onConfirm: handleAddJugadorConfirm
        }, null, 8, ["isVisible", "torneo"]),
        _createVNode(ModalSorteo, {
          isVisible: showSorteoModal.value,
          participantes: nicks.value,
          onClose: closeSorteoModal
        }, null, 8, ["isVisible", "participantes"])
      ]),
      _: 3
    }),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Jugador añadido correctamente.",
      "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalPago.value,
      message: "Estado del pago actualizado.",
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showSuccessModalPago.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessAddLista.value,
      message: "Lista subida con exito.",
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showSuccessAddLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessEditLista.value,
      message: "Lista modificada con exito.",
      "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showSuccessEditLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessEliminarInscripcion.value,
      message: "Inscripción eliminada con exito.",
      "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => (showSuccessEliminarInscripcion.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessUpdateEstadoLista.value,
      message: "Estado de la lista actualizado con exito.",
      "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => (showSuccessUpdateEstadoLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido actualizar la inscripción. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorAddLista.value,
      message: "No se ha podido subir la lista. Si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showErrorAddLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorUpdateEstadoLista.value,
      message: "No se ha podido actualizar el estado de la lista. Si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[10] || (_cache[10] = ($event: any) => (showErrorUpdateEstadoLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorEliminarInscripcion.value,
      message: "No se ha podido eliminar la inscripción. Si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[11] || (_cache[11] = ($event: any) => (showErrorEliminarInscripcion.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorEditLista.value,
      message: "No se ha podido cambiar la lista. Si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[12] || (_cache[12] = ($event: any) => (showErrorEditLista.value = $event))
    }, null, 8, ["isVisible"]),
    (currentInscripcionId.value != undefined && currentInscripcionId.value != null)
      ? (_openBlock(), _createBlock(ModalSubirListaGestionMas, {
          key: 0,
          isVisible: showModalAddLista.value,
          idInscripcion: currentInscripcionId.value!,
          "onUpdate:isVisible": _cache[13] || (_cache[13] = ($event: any) => (showModalAddLista.value = $event)),
          onEnviarLista: handleEnviarLista
        }, null, 8, ["isVisible", "idInscripcion"]))
      : _createCommentVNode("", true),
    (currentLista.value != null && currentLista.value != undefined)
      ? (_openBlock(), _createBlock(ModalModificarLista, {
          key: 1,
          isVisible: showModalEditLista.value,
          idLista: currentLista.value!.idLista!,
          "onUpdate:isVisible": _cache[14] || (_cache[14] = ($event: any) => (showModalEditLista.value = $event)),
          onModificarListaMasDeUna: modificarLista
        }, null, 8, ["isVisible", "idLista"]))
      : _createCommentVNode("", true),
    (showVerListaModal.value)
      ? (_openBlock(), _createBlock(ModalListaResultadoTorneo, {
          key: 2,
          listaData: listaData.value,
          ejercito: currentEjercito.value,
          nickJugador: currentNick.value!,
          onClose: _cache[15] || (_cache[15] = ($event: any) => (showVerListaModal.value = false))
        }, null, 8, ["listaData", "ejercito", "nickJugador"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: isLoading.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((isLoading).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})